module.exports = __webpack_public_path__ + "img/icon_white_tshirt.8d4f5a0c.svg";